import { Button } from "@mui/material"
import { CloseSnackBar } from "event-definitions"

/**
 * The Undo button on the message shown after an assignment is removed from the board.
 */
export function UndoSnackbarAction({ snackbarKey, onUndo }) {
    return (
        <Button size="small" color="inherit" onClick={handleUndo} data-cy="assignment-undo">
            Undo
        </Button>
    )

    function handleUndo() {
        CloseSnackBar.raise(snackbarKey)
        onUndo()
    }
}
